import { Component, Input, OnInit } from "@angular/core";
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";
import { ModuleManager } from "src/shared/models/module-manager";
import { ModuleManagerRefreshType } from "src/shared/models/module-manager/module-manager-options.model";
import { ErrorList, MyRankingData, MyRankingProfile } from "./my-ranking.model";
import { MyRankingService } from "./my-ranking.service";
@Component({
    selector: "cv-my-ranking",
    templateUrl: "./my-ranking.component.html",
    styleUrls: ["./my-ranking.component.scss"],
})
export class MyRankingComponent implements OnInit {
    @Input() moduleManager: ModuleManager;
    @Input() moduleKey: string;

    //#region Data
    profileData: MyRankingProfile = null;
    data: MyRankingData[] = null;
    isDataLoading = false;
    isFirstLoad = true;
    noData = true;
    noMetric = false;
    //#endregion

    //#region Localizations
    public position = '';
    public myRank = '';
    public high = '';
    public mid = '';
    public low = '';
    public description = '';
    //#endregion

    constructor(
        private cvLocalizationService: CVLocalizationService,
        private service: MyRankingService,
    ) { }

    async ngOnInit(): Promise<void> {
        // Pull localizations
        const myRankingLocalization: Map<string,string> = await this.cvLocalizationService.GetSection('My_Ranking');

        this.position = myRankingLocalization.get('Position');
        this.myRank = myRankingLocalization.get('My_Rank');
        this.high = myRankingLocalization.get('High_Rankings');
        this.mid = myRankingLocalization.get('Mid_Rankings');
        this.low = myRankingLocalization.get('Low_Rankings');
        this.description = myRankingLocalization.get('Rank_Description');

        // Set up module manager options
        this.moduleManager.setOptions({
            enableWidthClass: false,
            widgetMode: false,
            onSettingsApplied: () => this.loadData(false),
            hasRefresh: true,
            refreshType: ModuleManagerRefreshType.Auto,
            onRefresh: isAutoRefresh => {
                if (!isAutoRefresh)
                    this.moduleManager.showLoader = true;
                this.loadData(isAutoRefresh);

            },
            canRefresh: () => !this.isDataLoading,
            onExport: (format, isCXOne) => this.service.getExport(this.moduleKey, format, isCXOne),
        });
    }

    private async loadData(isAutoRefresh) {
        // Return if data is currently loading
        if (this.isDataLoading) {
            return;
        }

        this.isDataLoading = true;
        if (!isAutoRefresh) {
            this.moduleManager.showLoader = true;
        }

        // Data load
        try {
            const response = await this.service.loadData(this.moduleKey, isAutoRefresh);
            this.profileData = response.profile;
            this.data = response.data;
            this.noData = !this.data;
            this.noMetric = response.error == ErrorList.NoMetric;

            if(!this.noMetric){
                this.moduleManager.container.showDateRange = true;
            }

        } catch (err) {
            this.moduleManager.handleLoadError(err, isAutoRefresh);
        } finally {
            this.moduleManager.showLoader = false;
            this.isDataLoading = false;
            this.isFirstLoad = false;
        }
    }
}

